import { render, staticRenderFns } from "./NotificationDialog.vue?vue&type=template&id=25905a66&scoped=true&"
import script from "./NotificationDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDialog.vue?vue&type=style&index=0&id=25905a66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25905a66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCheckbox})
